import axios from 'axios';
import { setInerceptors } from './common/interceptors';

function createInstance() {
  const instance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
  });
  return setInerceptors(instance);
}

export const instance = createInstance();
